<template>
  <div>
    <el-tag>
      Attributes: <b>{{ stats.total }}</b>
    </el-tag>

    <el-tooltip v-if="stats.valid">
      <div slot="content">
        <el-table :data="examples.valid" :border="true" size="mini">
          <el-table-column
            prop="old_value"
            label="Old Value"
            :formatter="valueFormatter"
          />

          <el-table-column
            prop="new_value"
            label="New Value"
            :formatter="valueFormatter"
          />
        </el-table>
      </div>
      <el-tag type="success">
        Valid: <b>{{ stats.valid }}</b>
      </el-tag>
    </el-tooltip>
    <el-tag v-else type="success">
      Valid: <b>{{ stats.valid }}</b>
    </el-tag>

    <el-tooltip v-if="stats.invalid">
      <div slot="content" v-if="stats.invalid">
        <el-table :data="examples.invalid" :border="true" size="mini">
          <el-table-column prop="value" label="Value" />
          <el-table-column prop="error" label="Error" />
        </el-table>
      </div>
      <el-tag type="danger">
        Invalid: <b>{{ stats.invalid }}</b>
      </el-tag>
    </el-tooltip>
    <el-tag v-else type="danger">
      Invalid: <b>{{ stats.invalid }}</b>
    </el-tag>

    <el-tag>
      Empty: <b>{{ stats.empty }}</b>
    </el-tag>

    <a :href="downloadLink">
      <i class="el-icon-download"> Full Report</i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'AttributeConversionStats',
  props: ['stats', 'examples', 'fileId'],
  computed: {
    downloadLink() {
      return '/file/private/download?id=' + this.fileId
    }
  },
  methods: {
    valueFormatter(row, col, value) {
      return typeof value === 'object' ? JSON.stringify(value) : value
    }
  }
}
</script>

<style scoped>
.el-tag {
  margin-right: 12px;
}

.el-table {
  width: 400px;
}

a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modules/data-manager/components/AttributeConversionStats.vue